import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const HourglassCircle = (props: IconProps) => (
  <svg
    {...props}
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.001 2.66699C23.3343 2.66699 29.334 8.66667 29.334 16C29.334 23.3333 23.3343 29.333 16.001 29.333C8.66764 29.333 2.66797 23.3333 2.66797 16C2.66797 8.66667 8.66764 2.66699 16.001 2.66699ZM11.334 8.66699C10.9343 8.66714 10.6681 8.9333 10.668 9.33301C10.668 9.7329 10.9342 9.99986 11.334 10H12.001V11.5332C12.001 11.7332 12.0008 11.8667 12.0674 12C12.134 12.7332 12.4678 13.3996 13.001 13.8662L13.4678 14.333C13.8011 14.733 14.0009 15.2665 14.001 15.7998V16.4668C14.0009 16.8668 13.8672 17.3337 13.6006 17.667L12.668 18.8662C12.468 19.1329 12.3345 19.4003 12.2012 19.667V19.7334C12.0679 20.1332 12.001 20.533 12.001 20.8662V22H11.334C10.9342 22.0001 10.668 22.2671 10.668 22.667C10.6681 23.0667 10.9343 23.3329 11.334 23.333H20.668C21.0677 23.3329 21.3338 23.0667 21.334 22.667C21.334 22.2671 21.0678 22.0001 20.668 22H20.001V20.8662C20.0009 20.4664 19.9341 20.1332 19.8008 19.7334V19.667C19.6674 19.4003 19.534 19.0662 19.334 18.8662L18.4014 17.5996C18.1348 17.2664 18.0011 16.8003 18.001 16.4004V15.7334C18.001 15.2001 18.2006 14.6663 18.6006 14.333L19.0674 13.8662C19.6007 13.3329 19.9343 12.6666 20.001 12V10H20.668C21.0678 9.99986 21.334 9.7329 21.334 9.33301C21.3338 8.9333 21.0677 8.66714 20.668 8.66699H11.334ZM16.668 16.667C16.7347 17.3335 16.9341 17.9336 17.334 18.4668L18.001 19.333H14.001L14.668 18.4668C15.0679 17.9336 15.2673 17.3335 15.334 16.667H16.668ZM18.668 11.333H13.334V10H18.668V11.333Z"
      fill="currentColor"
    />
  </svg>

)

export default HourglassCircle
